var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ee652a;}.cls-3{fill:#e24f26;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m130.62,379.81l-24.01-293.48,286.79.59-25.39,292.9-116.92,33.86-120.46-33.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m251.08,385.33V114.28l118.1.39-21.06,242.5-97.04,28.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m336.71,181.99l3.34-35.83h-181.68l10.04,109.84h125.39l-4.92,46.85-40.16,10.82-40.75-11.81-2.16-27.95h-36.02l4.92,57.08,74.01,20.67,74.6-20.67,10.04-111.41h-131.68l-3.74-37.6h138.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5Icon);
export default __webpack_public_path__ + "static/media/html5_icon.5e5e1b61b03a10f31a348d2688e3d567.svg";
export { ForwardRef as ReactComponent };